"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { Icon } from "@/components/ui/Icon";
import { whatsappLink, contactEmail } from "@/config/infos";
import type { Locale } from "@/config/i18n";
import { tr } from "@/config/localeText";
import { CONTACT_UI } from "@/(global)/contact/components/contactDict";

export const HeroSection = ({
  locale = "fr",
}: {
  locale?: Locale;
}): JSX.Element => {
  const t = tr(CONTACT_UI, locale).hero;
  return (
    <section className="relative isolate overflow-hidden">
      <div className="mx-auto max-w-[90rem] px-6 pb-12 pt-24 md:px-8 lg:pt-28">
        <motion.p
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-2 text-sm uppercase tracking-[0.35em] text-black/55"
        >
          {t.eyebrow}
        </motion.p>
        <motion.h1
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
          className="mb-3 font-space-age text-3xl tracking-[0.25em] text-black md:text-4xl"
        >
          {t.title}
        </motion.h1>
        <p className="max-w-2xl text-black/70">{t.intro}</p>
        <div className="mt-4 flex flex-wrap items-center gap-3 text-sm text-black/80">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-lg border border-black/15 bg-black/[0.02] px-3 py-1.5 transition-colors hover:border-primary"
          >
            <Icon icon="mdi:whatsapp" className="h-4 w-4" /> {t.whatsapp}
          </a>
          <Link
            href={`mailto:${contactEmail}`}
            className="inline-flex items-center gap-2 rounded-lg border border-black/15 bg-black/[0.02] px-3 py-1.5 transition-colors hover:border-primary"
          >
            <Icon icon="mdi:email" className="h-4 w-4" /> {t.email}
          </Link>
        </div>
      </div>
    </section>
  );
};
